// cSpell:ignore forfait
// A cost billed right away never bills a tenant whose lease prices that
// kind of costs as a forfait (decision 20, 2026-10-20): a forfait is never
// settled, also not through an immediate payment request. That tenant's
// share stays with the owner of their unit, the way a settlement leaves it
// there (see the engine's forfait kinds). A building's cost is a common
// cost, a unit's own cost a private one (costKindOf).

import { ContractRef } from "./types";

export const isFixedFeeForCost = (params: {
  lease: Pick<ContractRef, "fixedFeeCommon" | "fixedFeePrivate">;
  // A building's cost (common); else a unit's own cost (private).
  isBuildingCost: boolean;
}): boolean =>
  params.isBuildingCost
    ? !!params.lease.fixedFeeCommon
    : !!params.lease.fixedFeePrivate;

// The leases of a cost billed right away that it does not bill.
export const fixedFeeLeaseIds = (params: {
  leases: Pick<ContractRef, "id" | "fixedFeeCommon" | "fixedFeePrivate">[];
  isBuildingCost: boolean;
}): Set<string> =>
  new Set(
    params.leases
      .filter(lease =>
        isFixedFeeForCost({ lease, isBuildingCost: params.isBuildingCost }),
      )
      .map(lease => lease.id),
  );
